export default class SelectableListOption {
    constructor() {
        this.selected = false;
    }
}
